import { provideDataClass } from "scrivito"

import { apolloClient } from "app/apolloRestLink"

import {
  ProjectDocument,
  ProjectQuery,
  ProjectQueryVariables,
  ProjectsDocument,
  ProjectsQuery,
  ProjectsQueryVariables
} from "entities/projects/graphql/queries.generated"

export const ProjectDataClass = provideDataClass("Project", {
  connection: {
    get: async id => {
      return apolloClient
        .query<ProjectQuery, ProjectQueryVariables>({
          query: ProjectDocument,
          variables: { id }
        })
        .then(result => {
          if (!result.data.project) return null

          return {
            ...result.data.project,
            _id: result.data.project.id,
            projectId: result.data.project.id
          }
        })
        .catch(() => {
          return null
        })
    },

    index: async () => {
      const projects = await apolloClient
        .query<ProjectsQuery, ProjectsQueryVariables>({
          query: ProjectsDocument
        })
        .then(result => result.data.projects)
        .catch(() => [])

      const results =
        projects?.map(project => {
          return {
            ...project,
            _id: project.id,
            projectId: project.id
          }
        }) || []

      return {
        results
      }
    }
  },
  attributes: {
    id: "string",
    projectId: "string",
    title: "string"
  }
})
